import { Card, Timeline } from 'antd';
import { ORDER_EXCHANGE_STATUS } from 'constants/ordersExchange';
import { orderBy } from 'lodash';
import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { DynamicObjectType } from 'types/commons';
import { formatDateTime } from 'utils/formattedString';

const getStatusText = ({ item }) => {
  return item?.text;
};

const OrderHistories = ({ data }: DynamicObjectType) => {
  const { t } = useTranslation();

  const getHistories = useCallback(() => {
    return orderBy(data?.histories, ['createdAt'], ['desc'])?.map((e) => {
      const currentStatus = ORDER_EXCHANGE_STATUS[e.status];
      return {
        // label: formatDateTime(e.createdAt),
        children: (
          <div>
            <div className="time-point">{formatDateTime(e.createdAt)}</div>
            <div className="font-semibold">
              {t(getStatusText({ item: currentStatus }))}
            </div>
            <div className="text-secondary mt-[10px]">
              {e?.creatorId
                ? `${e.creator?.firstName || ''} ${e.creator?.lastName || ''}: ${e?.comment || ''}`
                : e?.comment}
              <div className="mt-1">
                {e?.note ? <>Note: {e?.note}</> : null}
              </div>
            </div>
          </div>
        ),
      };
    });
  }, [data, t]);

  return (
    <CardWrapper title={t('Histories')}>
      <div className="w-full">
        <div className="mt-[30px]">
          <TimelineStyles
            className="mt-[40px]"
            mode="left"
            items={getHistories()}
          ></TimelineStyles>
        </div>
      </div>
    </CardWrapper>
  );
};

export const CardWrapper = styled(Card)`
  .ant-card-head {
    padding: 10px 16px;
  }
  .ant-card-body {
    padding: 10px 20px;
  }
`;

const TimelineStyles = styled(Timeline)`
  padding-left: 150px;

  .time-point {
    position: absolute;
    left: -160px;
  }
`;

export default OrderHistories;
